module.exports = __webpack_public_path__ + "img/70.f1dc5010.jpg";